import { BaseIcon } from './Base';
import { CustomSvgIconProps, IconType } from './constants';

export const LogoIcon = ({
  width = '22px',
  height = '16px',
  variant = IconType.Pure,
}: CustomSvgIconProps) => (
  <BaseIcon
    src="../../public/logo.svg"
    alt="Guy Carpenter Logo"
    width={width}
    height={height}
    variant={variant}
  />
);
